<h1 mat-dialog-title [attr.data-cy]="'smasmasm_h1_1_4_'"
    >Artikellieferant{{ supplierMaterial ? " " + supplierMaterial.lieferant : "" }} f&uuml;r {{ material.bezeichnung }}
    {{ create ? "hinzufügen" : "editieren" }}</h1
>
<div mat-dialog-content>
    <div *ngIf="create">
        <kiene-autocomplete
            [apiUrl]="'lieferant/'"
            [placeholder]="'Lieferant'"
            [displayFields]="['bezeichnung', 'bezeichnung_1']"
            [separator]="' / '"
            (elementSelected)="setSupplier($event)"
            [attr.data-cy]="'smasmasm_autocomplete_1_1_'"
        >
        </kiene-autocomplete>
    </div>

    <mat-form-field>
        <mat-label>Einkaufspreis</mat-label>
        <input matInput type="number" [formControl]="preisCtrl" [attr.data-cy]="'smasmasm_input_1_1_'" />
    </mat-form-field>
    <br />
    <mat-form-field>
        <mat-label>Rabatt (%)</mat-label>
        <input matInput type="number" [formControl]="rabattCtrl" [attr.data-cy]="'smasmasm_input_2_1_'" />
    </mat-form-field>
    <br />
    <mat-form-field>
        <mat-label>Skonto (%)</mat-label>
        <input [formControl]="skontoCtrl" matInput type="number" [attr.data-cy]="'smasmasm_input_3_1_'" />
    </mat-form-field>
    <br />
    <mat-form-field>
        <mat-label>Zahlungsziel (Tage)</mat-label>
        <input [formControl]="zahlungszielCtrl" matInput type="number" [attr.data-cy]="'smasmasm_input_4_1_'" />
    </mat-form-field>
    <br />
    <mat-checkbox
        [disabled]="isStandardLieferant"
        [formControl]="standardCtrl"
        [attr.data-cy]="'smasmasm_mat-checkbox_1_3_'"
        >Standardlieferant</mat-checkbox
    >
    <div *kienePermission="[1095]">
        <div *ngIf="availableMandanten.length > 0" style="margin-top: 24px">
            <mat-divider></mat-divider>
            <h5>Soll die &Auml;nderung f&uuml;r folgende Mandanten &uuml;bernommen werden?</h5>
            <ul style="list-style-type: none">
                <li *ngFor="let m of availableMandanten; let i = index" [attr.data-cy]="'smasmasm_li_1_5_' + i">
                    <mat-checkbox
                        [formControl]="mandantCtrl[m.mandant_id]"
                        (change)="updateSelectedMandanten()"
                        [attr.data-cy]="'smasmasm_mat-checkbox_2_3_' + i"
                        >{{ m.bezeichnung }}
                    </mat-checkbox>
                </li>
            </ul>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-button (click)="close()" [attr.data-cy]="'smasmasm_button_1_0_'">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()" [attr.data-cy]="'smasmasm_button_2_0_'">Speichern</button>
</div>
